import { styled } from "@mui/material/styles";
import { Drawer as MuiDrawer } from "@mui/material";
import { openedMixin, closedMixin } from "./Mixins";

import { drawerWidth } from "./drawerWidth";

let w = document.documentElement.clientWidth || window.innerWidth;

export const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  [theme.breakpoints.down("md")]: {
    marginBottom: -15,
  },
  [theme.breakpoints.up("md")]: {
    marginBottom: -25,
  },
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));
